import { useTranslation } from 'react-i18next'
import { Button, ButtonProps } from 'ui/button'

import { useCanDisplayInstallOnAndroid } from '~/boundedContext/settings/hooks/use-can-display-install-on-android'
import { useBeforeInstallPromptContext } from '~/providers/before-install-prompt-provider'
import { useSettingsStore } from '~/stores/settings'

export const BeforeInstallPromptButton = ({ onClick }: Pick<ButtonProps, 'onClick'>) => {
  const { beforeInstallPromptEvent, reset } = useBeforeInstallPromptContext()
  const { t } = useTranslation()
  const patchSettings = useSettingsStore(state => state.patchSettings)

  if (!useCanDisplayInstallOnAndroid()) return null

  return (
    <Button
      onClick={async e => {
        onClick?.(e)
        if (!beforeInstallPromptEvent) return

        void beforeInstallPromptEvent.prompt()
        const { outcome } = await beforeInstallPromptEvent.userChoice
        if (outcome === 'dismissed') return

        patchSettings({ appWasInstalled: true })

        reset()
      }}
      variant="secondary"
    >
      {t('Install')}
    </Button>
  )
}
